import {Injectable} from '@angular/core';

@Injectable()
export class AppSettings {

  public get(key: string, default_p?): any {
    return [undefined, null].indexOf(localStorage.getItem(key)) < 0 ? localStorage.getItem(key) : default_p;
  }

  public set(key: string, val: string): void {
    localStorage.setItem(key, val);
  }

  public exists(key: string): boolean {
    return localStorage.getItem(key) !== undefined;
  }

  public unset(key: string): void {
    localStorage.removeItem(key);
  }

  public unsetAll(): void {
    localStorage.clear();
  }
}
